"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeResponse = safeResponse;
exports.init = init;
exports.getInstitutions = getInstitutions;
exports.loginPreload = loginPreload;
exports.login = login;
exports.mfa = mfa;
exports.getStatementData = getStatementData;
exports.submitSelectedIncome = submitSelectedIncome;
exports.submitError = submitError;
exports.default = exports.getProvisoApi = exports.userTokenInterceptor = exports.guidInterceptor = exports.getBankConnectApi = exports.bankConnectUserTokenInterceptor = exports.successAdapter = exports.errorAdapter = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _axios = _interopRequireDefault(require("axios"));

var _browserRum = require("@datadog/browser-rum");

var _env = _interopRequireDefault(require("../env.config"));

var _mocks = require("../__mocks");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var errorAdapter = function errorAdapter(data) {
  return function (config) {
    // console.warn('>>>>> errorAdapter', data, config);
    return Promise.reject({
      config: config,
      isAxiosError: true,
      response: {
        data: data,
        status: 400,
        statusText: 'Bad Request',
        headers: {},
        config: config
      },
      toJSON: function toJSON() {}
    });
  };
};

exports.errorAdapter = errorAdapter;

var successAdapter = function successAdapter(data) {
  return function (config) {
    // console.warn('>>>>> successAdapter', data, config);
    return Promise.resolve({
      data: data,
      status: 200,
      statusText: '',
      headers: {},
      config: config
    });
  };
};

exports.successAdapter = successAdapter;

var bankConnectUserTokenInterceptor = function bankConnectUserTokenInterceptor(userToken) {
  return function (config) {
    var data = config.data;

    if (data && (0, _typeof2.default)(data) === 'object' && !Array.isArray(data)) {
      config.data = _objectSpread(_objectSpread({}, data), {}, {
        userToken: userToken
      });
    }

    return config;
  };
};

exports.bankConnectUserTokenInterceptor = bankConnectUserTokenInterceptor;

var getBankConnectApi = function getBankConnectApi(userToken, adapter) {
  var instance = _axios.default.create({
    baseURL: (0, _env.default)('BANK_CONNECT_API_URL'),
    adapter: undefined ? (0, _mocks.getStorybookAdapter)(userToken) : adapter
  });

  if (userToken) {
    instance.interceptors.request.use(bankConnectUserTokenInterceptor(userToken));
  }

  return instance;
};

exports.getBankConnectApi = getBankConnectApi;

var guidInterceptor = function guidInterceptor(guid) {
  return function (config) {
    var url = config.url;
    var path = (url === null || url === void 0 ? void 0 : url.charAt(-1)) === '/' ? url.substr(0, url.length - 1) : url;
    config.url = path + '/' + guid;
    return config;
  };
};

exports.guidInterceptor = guidInterceptor;

var userTokenInterceptor = function userTokenInterceptor(userToken) {
  return function (config) {
    var data = config.data;

    if (data && (0, _typeof2.default)(data) === 'object' && !Array.isArray(data)) {
      config.data = _objectSpread(_objectSpread({}, data), {}, {
        user_token: userToken
      });
    }

    return config;
  };
};

exports.userTokenInterceptor = userTokenInterceptor;

var getProvisoApi = function getProvisoApi(userToken, guid, adapter, responseInterceptor) {
  var instance = _axios.default.create({
    baseURL: (0, _env.default)('PROVISO_API_URL'),
    withCredentials: false,
    adapter: undefined ? (0, _mocks.getStorybookAdapter)(userToken) : adapter,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-OUTPUT-VERSION': '20170401'
    }
  });

  instance.interceptors.request.use(userTokenInterceptor(userToken));
  instance.interceptors.request.use(guidInterceptor(guid));
  responseInterceptor && instance.interceptors.response.use(function (response) {
    try {
      responseInterceptor(response);
    } catch (e) {}

    return response;
  });
  return instance;
};

exports.getProvisoApi = getProvisoApi;

function safeResponse(_x) {
  return _safeResponse.apply(this, arguments);
}

function _safeResponse() {
  _safeResponse = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(request) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return request.then(function (response) {
              return response.data;
            }).catch(function (e) {
              var _e$response, _e$response2, _e$response3;

              var data = (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data;
              var status = ((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) || 500;
              var statusText = (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.statusText;
              var payload = {
                status: status,
                error: data ? typeof data === 'string' ? {
                  error: statusText,
                  errorCode: status
                } : data : {
                  error: 'Unable to contact server',
                  errorCode: status
                }
              };

              _browserRum.datadogRum.addError(payload, undefined);

              return payload;
            });

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _safeResponse.apply(this, arguments);
}

function init() {
  return _init.apply(this, arguments);
}

function _init() {
  _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
    var initApi;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            initApi = _axios.default.create({
              baseURL: "http://localhost:3002"
            });
            _context9.next = 3;
            return safeResponse(initApi.get('/config'));

          case 3:
            return _context9.abrupt("return", _context9.sent);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _init.apply(this, arguments);
}

function getInstitutions(api) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(countryCode) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return safeResponse(api.get('/institutions', {
                params: {
                  region: countryCode
                }
              }));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function loginPreload(api) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(institution) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return safeResponse(api.post('/cs_preload', {
                institution: institution
              }));

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function login(api) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(credentials) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return safeResponse(api.post('/cs_login', {
                credentials: credentials
              }));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function mfa(api) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(payload) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return safeResponse(api.post('/cs_mfa', payload));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function getStatementData(api) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(data) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return safeResponse(api.post('/cs_export', data));

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function submitSelectedIncome(api) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(data) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return safeResponse(api.post('/incomeselection', data));

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function submitError(api) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(data) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return safeResponse(api.post('/errors', data));

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x8) {
      return _ref7.apply(this, arguments);
    };
  }();
}

var apiClient = {
  init: init,
  getInstitutions: getInstitutions,
  loginPreload: loginPreload,
  login: login,
  mfa: mfa,
  getStatementData: getStatementData,
  submitError: submitError
};
var _default = apiClient;
exports.default = _default;